module.exports = __webpack_public_path__ + "img/stripes-bg.4e21b3dc.svg";